export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtMotorpopis';
export const NAME = 'PopisMotoru';
